import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-cbee079c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {"transform":"rotate(90deg)"},
  class: "pi pi-bars"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_PosChooseStock = _resolveComponent("PosChooseStock")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_openBlock(), _createElementBlock("form", {
    autocomplete: "off",
    spellcheck: "false",
    class: "p-inputgroup p-p-0",
    onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleCode && _ctx.handleCode(...args)), ["prevent"]))
  }, [
    _createVNode(_component_Button, {
      tabindex: "-1",
      class: "p-inputgroup-addon code-bar p-button-secondary"
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createVNode(_component_InputText, {
      tabindex: "-1",
      onKeydown: _ctx.handleKeyup,
      id: "code-bar-input",
      autofocus: "",
      modelValue: _ctx.search,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
      placeholder: _ctx.$t('product.codeBarPlaceholder'),
      class: "p-text-center p-text-bold code-bar"
    }, null, 8, ["onKeydown", "modelValue", "placeholder"]),
    _createVNode(_component_Button, {
      class: "p-inputgroup-addon code-bar p-px-4 p-button-secondary",
      icon: "pi pi-search",
      type: "submit",
      id: "submit-code-found"
    }),
    _createVNode(_component_OverlayPanel, {
      ref: "stockOverlay",
      dismissable: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_PosChooseStock, {
          quantity: _ctx.saleRow.quantity,
          "onUpdate:quantity": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.saleRow.quantity) = $event)),
          id: _ctx.saleRow.stockId,
          "onUpdate:id": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.saleRow.stockId) = $event)),
          onClose: _ctx.onQuantityValidate,
          stocks: _ctx.stocks
        }, null, 8, ["quantity", "id", "onClose", "stocks"])
      ]),
      _: 1
    }, 512)
  ], 32))
}